<span
  class="investor-card-icon-wrapper"
  [ouiTooltip]="statusLabel()"
  ouiTooltipPosition="top">
  <oui-icon class="investor-card-icon investor-card-icon--{{ tagStatus() }}"> frame_person </oui-icon>
</span>
<div class="investor-card-content">
  <div class="investor-card-header body-2">{{ code() }} • #{{ id() }}</div>
  <div class="investor-card-body">
    <a
      class="investor-card-name subtitle-1"
      target="_blank"
      [routerLink]="link()"
      >{{ name() }}</a
    >
  </div>
</div>
